import api from 'api'
import type {
  InvoiceConfig,
  InvoiceConfigCustomWeek,
} from './getInvoiceConfigs'

export type CreateInvoiceConfigRequest = {
  companyId: number | null
  companyGroupId: number | null
  breakdownLevels: InvoiceConfig['breakdownLevels']
  customWeek: InvoiceConfigCustomWeek | null
}

export type CreateInvoiceConfigResponse = {
  id: number
  createdAt: string
}

export const createInvoiceConfig = async (
  body: CreateInvoiceConfigRequest
): Promise<CreateInvoiceConfigResponse> => {
  const response = await api.post<CreateInvoiceConfigResponse>(
    '/admin/invoice_config',
    body
  )
  return response.data
}
